<style lang="scss">
.skillcirclecontainer {
  $color-progress-circle: #ebebeb;
  $color-progress-idicator: $c-blue;
  $color-progress-idicator-hover: $c-medium-blue;
  position: relative;
  top: 7px;

  .progress-circle {
    position: relative;
    display: inline-block;
    margin: 1rem;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: $color-progress-circle;
    outline: 1px solid $c-blue;
    outline-offset: -1px;

    transition: 0.2s all;
    &.dynamic {
      cursor: pointer;
      &:hover {
        transform: scale(1.05);
        filter: brightness(110%);
      }
    }
  }

  &.active {
    .progress-circle {
      background-color: $color-progress-idicator-hover;
      outline: 1px solid $color-progress-idicator-hover;
    }
  }

  .progress-circle:after {
    content: '';
    display: inline-block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    -webkit-animation: colorload 2s;
    animation: colorload 2s;
  }
  /*#region*/

  .progress-circle.progress-0:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(90deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-1:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(93.6deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-2:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(97.2deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-3:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(100.8deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-4:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(104.4deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-5:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(108deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-6:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(111.6deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-7:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(115.2deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-8:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(118.8deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-9:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(122.4deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-10:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(126deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-11:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(129.6deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-12:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(133.2deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-13:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(136.8deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-14:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(140.4deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-15:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(129.6deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-16:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(133.2deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-17:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(136.8deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-18:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(140.4deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-19:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(144deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-20:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(151.2deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-21:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(158.6deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-22:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(161.2deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-23:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(165.6deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-24:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(169.2deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-25:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(180deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-26:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(183.6deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-27:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(187.2deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-28:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(190.8deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-29:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(194.4deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-30:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(198deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-31:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(201.6deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-32:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(205.2deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-33:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(208.8deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-34:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(212.4deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-35:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(216deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-40:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(234deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-36:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(219.6deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-37:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(223.2deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-38:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(226.8deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-39:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(230.4deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-41:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(237.6deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-42:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(241.2deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-43:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(244.8deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-44:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(248.4deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-45:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(252deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-46:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(255.6deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-47:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(259.2deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-48:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(262.8deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-49:after {
    background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
      linear-gradient(266.4deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-50:after {
    background-image: linear-gradient(-90deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-51:after {
    background-image: linear-gradient(-86.4deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-52:after {
    background-image: linear-gradient(-82.6deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-53:after {
    background-image: linear-gradient(-79.2deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-54:after {
    background-image: linear-gradient(-75.6deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-55:after {
    background-image: linear-gradient(-72deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-56:after {
    background-image: linear-gradient(-68.4deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-57:after {
    background-image: linear-gradient(-64.8deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-58:after {
    background-image: linear-gradient(-61.2deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-59:after {
    background-image: linear-gradient(-57.6deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-60:after {
    background-image: linear-gradient(-54deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-61:after {
    background-image: linear-gradient(-50.4deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-62:after {
    background-image: linear-gradient(-46.8deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-63:after {
    background-image: linear-gradient(-43.2deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-64:after {
    background-image: linear-gradient(-39.6deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-65:after {
    background-image: linear-gradient(-36deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-66:after {
    background-image: linear-gradient(-32.4deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-67:after {
    background-image: linear-gradient(-28.8deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-68:after {
    background-image: linear-gradient(-25.2deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-69:after {
    background-image: linear-gradient(-21.6deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-70:after {
    background-image: linear-gradient(-18deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-71:after {
    background-image: linear-gradient(-14.4deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-72:after {
    background-image: linear-gradient(-10.8deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-73:after {
    background-image: linear-gradient(-7.2deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-74:after {
    background-image: linear-gradient(-3.6deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-75:after {
    background-image: linear-gradient(0deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-76:after {
    background-image: linear-gradient(3.6deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-77:after {
    background-image: linear-gradient(7.2deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-78:after {
    background-image: linear-gradient(10.8deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-79:after {
    background-image: linear-gradient(14.4deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-80:after {
    background-image: linear-gradient(18deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-81:after {
    background-image: linear-gradient(21.6deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-82:after {
    background-image: linear-gradient(25.2deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-83:after {
    background-image: linear-gradient(28.8deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-84:after {
    background-image: linear-gradient(32.4deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-85:after {
    background-image: linear-gradient(36deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-86:after {
    background-image: linear-gradient(39.2deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-87:after {
    background-image: linear-gradient(43.2deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-88:after {
    background-image: linear-gradient(46.8deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-89:after {
    background-image: linear-gradient(50.4deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-90:after {
    background-image: linear-gradient(54deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-91:after {
    background-image: linear-gradient(57.6deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-92:after {
    background-image: linear-gradient(61.2deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-93:after {
    background-image: linear-gradient(64.8deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-94:after {
    background-image: linear-gradient(68.4deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-95:after {
    background-image: linear-gradient(72deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-96:after {
    background-image: linear-gradient(75.6deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-97:after {
    background-image: linear-gradient(79.2deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-98:after {
    background-image: linear-gradient(82.8deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-99:after {
    background-image: linear-gradient(86.4deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  .progress-circle.progress-100:after {
    background-image: linear-gradient(90deg, $color-progress-idicator 50%, transparent 50%, transparent),
      linear-gradient(270deg, $color-progress-idicator 50%, $color-progress-circle 50%, $color-progress-circle);
  }

  /*#endregion*/

  &.active {
    .progress-circle.progress-0:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(90deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-1:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(93.6deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-2:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(97.2deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-3:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(100.8deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-4:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(104.4deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-5:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(108deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-6:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(111.6deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-7:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(115.2deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-8:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(118.8deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-9:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(122.4deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-10:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(126deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-11:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(129.6deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-12:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(133.2deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-13:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(136.8deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-14:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(140.4deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-15:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(129.6deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-16:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(133.2deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-17:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(136.8deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-18:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(140.4deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-19:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(144deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-20:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(151.2deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-21:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(158.6deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-22:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(161.2deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-23:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(165.6deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-24:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(169.2deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-25:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(180deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-26:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(183.6deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-27:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(187.2deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-28:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(190.8deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-29:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(194.4deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-30:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(198deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-31:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(201.6deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-32:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(205.2deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-33:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(208.8deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-34:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(212.4deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-35:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(216deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-40:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(234deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-36:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(219.6deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-37:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(223.2deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-38:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(226.8deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-39:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(230.4deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-41:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(237.6deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-42:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(241.2deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-43:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(244.8deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-44:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(248.4deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-45:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(252deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-46:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(255.6deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-47:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(259.2deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-48:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(262.8deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-49:after {
      background-image: linear-gradient(90deg, $color-progress-circle 50%, transparent 50%, transparent),
        linear-gradient(266.4deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-50:after {
      background-image: linear-gradient(-90deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-51:after {
      background-image: linear-gradient(-86.4deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-52:after {
      background-image: linear-gradient(-82.6deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-53:after {
      background-image: linear-gradient(-79.2deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-54:after {
      background-image: linear-gradient(-75.6deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-55:after {
      background-image: linear-gradient(-72deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-56:after {
      background-image: linear-gradient(-68.4deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-57:after {
      background-image: linear-gradient(-64.8deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-58:after {
      background-image: linear-gradient(-61.2deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-59:after {
      background-image: linear-gradient(-57.6deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-60:after {
      background-image: linear-gradient(-54deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-61:after {
      background-image: linear-gradient(-50.4deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-62:after {
      background-image: linear-gradient(-46.8deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-63:after {
      background-image: linear-gradient(-43.2deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-64:after {
      background-image: linear-gradient(-39.6deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-65:after {
      background-image: linear-gradient(-36deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-66:after {
      background-image: linear-gradient(-32.4deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-67:after {
      background-image: linear-gradient(-28.8deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-68:after {
      background-image: linear-gradient(-25.2deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-69:after {
      background-image: linear-gradient(-21.6deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-70:after {
      background-image: linear-gradient(-18deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-71:after {
      background-image: linear-gradient(-14.4deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-72:after {
      background-image: linear-gradient(-10.8deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-73:after {
      background-image: linear-gradient(-7.2deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-74:after {
      background-image: linear-gradient(-3.6deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-75:after {
      background-image: linear-gradient(0deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-76:after {
      background-image: linear-gradient(3.6deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-77:after {
      background-image: linear-gradient(7.2deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-78:after {
      background-image: linear-gradient(10.8deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-79:after {
      background-image: linear-gradient(14.4deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-80:after {
      background-image: linear-gradient(18deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-81:after {
      background-image: linear-gradient(21.6deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-82:after {
      background-image: linear-gradient(25.2deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-83:after {
      background-image: linear-gradient(28.8deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-84:after {
      background-image: linear-gradient(32.4deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-85:after {
      background-image: linear-gradient(36deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-86:after {
      background-image: linear-gradient(39.2deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-87:after {
      background-image: linear-gradient(43.2deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-88:after {
      background-image: linear-gradient(46.8deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-89:after {
      background-image: linear-gradient(50.4deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-90:after {
      background-image: linear-gradient(54deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-91:after {
      background-image: linear-gradient(57.6deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-92:after {
      background-image: linear-gradient(61.2deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-93:after {
      background-image: linear-gradient(64.8deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-94:after {
      background-image: linear-gradient(68.4deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-95:after {
      background-image: linear-gradient(72deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-96:after {
      background-image: linear-gradient(75.6deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-97:after {
      background-image: linear-gradient(79.2deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-98:after {
      background-image: linear-gradient(82.8deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-99:after {
      background-image: linear-gradient(86.4deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }

    .progress-circle.progress-100:after {
      background-image: linear-gradient(90deg, $color-progress-idicator-hover 50%, transparent 50%, transparent),
        linear-gradient(270deg, $color-progress-idicator-hover 50%, $color-progress-circle 50%, $color-progress-circle);
    }
  }

  .selector {
    z-index: 99;
    background-color: $c-white;
    display: inline-block;
    position: absolute;
    top: -55px;
    left: 50%;
    transform: translate(0, 100%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
    width: 250px;
    margin-left: -25px;
    padding: 15px;

    .pie {
      margin: 5px;
      background-color: $c-medium-grey;
    }
    .arrow {
      top: 0;
      left: 30px;
      transform: translateY(-100%);
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 20px 0 0 20px;
      border-color: transparent transparent transparent $c-white;
    }
  }
}
</style>

<template>
  <div class="skillcirclecontainer">
    <!-- <div class="skillcircle" :class="[`circle-${pieslices}`, statik ? 'static' : 'dynamic']"></div> -->
    <div
      class="pie progress-circle"
      :data-value="percent"
      @click="toggle"
      :class="[statik ? 'static' : 'dynamic', { show: percent > 0 }, `progress-${percent}`]"
    ></div>
    <div class="selector" v-if="open && !statik">
      <div class="arrow"></div>
      <div class="pie dynamic progress-0" @click="onChange(0)"></div>
      <div class="progress-circle pie dynamic progress-17 show" @click="onChange(0.17)"></div>
      <div class="progress-circle pie dynamic progress-33 show" @click="onChange(0.33)"></div>
      <div class="progress-circle pie dynamic progress-50 show" @click="onChange(0.5)"></div>
      <div class="progress-circle pie dynamic progress-67 show" @click="onChange(0.67)"></div>
      <div class="progress-circle pie dynamic progress-83 show" @click="onChange(0.83)"></div>
      <div class="progress-circle pie dynamic progress-100 show" @click="onChange(1)"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, Static, inject } from 'vue';
import { Emitter } from 'mitt';

export default defineComponent({
  props: {
    modelValue: Number,
    value: Number,
    locked: { type: Boolean, default: false },
    slices: { type: Number, default: -1 },
  },
  setup(props, { emit }) {
    const roundOff = (num: number, places: number) => {
      // if (!num) return undefined;
      const x = Math.pow(10, places);
      return Math.round(num * x) / x;
    };

    const model = computed({
      get: () => {
        let val = props.modelValue || props.value || 0;
        if (Number.isInteger(parseInt(val.toString())) && val >= 0 && val <= 1) {
          return val;
        } else if (Number.isInteger(parseInt(val.toString())) && val >= 1) {
          return 1;
        } else {
          return 0;
        }
      },
      set: (id: any) => emit('update:modelValue', id),
    });

    const open = ref(false);
    //c; //onst statik = ref(false);

    const onChange = (value: number) => {
      model.value = value;
      open.value = false;
    };

    const toggle = () => {
      if (!open.value) mitt.emit('closedropdowns', '');
      if (!statik.value) open.value = !open.value;
    };

    // const slicesize = roundOff(100 / props.slices, 2);

    const percent = computed(() => {
      if (props.slices == -1) return Math.round(model.value * 100);
      if (model.value <= 0.085) return 0;
      if (model.value <= 0.17 + 0.085) return 17;
      if (model.value <= 0.33 + 0.085) return 33;
      if (model.value <= 0.5 + 0.085) return 50;
      if (model.value <= 0.67 + 0.085) return 67;
      if (model.value <= 0.83 + 0.085) return 83;
      //if(model.value < )

      // for (let i = 0; i <= props.slices; i++) {
      //   console.log(slicesize, i, i * slicesize >= Math.round(model.value * 100));
      //   if (i * slicesize >= model.value * 100) {
      //     return Math.round(i * slicesize);
      //     // const diff = roundOff(i * slicesize - model.value * 100, 2);
      //     // console.log(diff);
      //     // if (diff >= slicesize / 2) {
      //     //   return Math.round((i - 1) * slicesize);
      //     // } else {
      //     //   return Math.round((i - 2) * slicesize);
      //     // }
      //   }
      //  }
      return 100;
    });

    const statik = computed(() => props.locked);
    const mitt = inject('emitter') as Emitter<{ closedropdowns: string }>;

    mitt.on('closedropdowns', () => {
      if (open.value) {
        open.value = false;
      }

      emit('closed');
    });

    return {
      statik,
      toggle,
      model,
      open,
      onChange,

      percent,
    };
  },
});
</script>
